import type { FaireProductEntity } from "../../entity_types/product";

export const p_jgw6g89cwb: FaireProductEntity = {
  token: "p_jgw6g89cwb",
  type: "product",
  name: "Botany Porcelain Plant Pot Medium",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl:
    "https://cdn.faire.com/fastly/fdaa1a2ba936f55c79c6b7f519b3a49c90c086f261744a4c9fd67b239057a374.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8bcbe80b24379713fb4120b4715ade5ec590c232ec709bd0f76f11bb69eab52b.jpeg",
    "https://cdn.faire.com/fastly/bcd35d4c1fb5c2f6c61a951287bedcb36221dc4da5503b929c3c4885813b1ed3.jpeg",
    "https://cdn.faire.com/fastly/f2f89c64535a0559977011c1c1f8ed0b86c18565cc4b63257eb98a3e33ed28b6.jpeg",
    "https://cdn.faire.com/fastly/e6a163f83c5a15aa9badde2b8fe478d121d12a9e42291a938968993d8e164cde.jpeg",
    "https://cdn.faire.com/fastly/98bd7cfafdba77faaa5d59a6e04a3b3f229a82fb8a5aac73ac16941039672452.jpeg",
    "https://cdn.faire.com/fastly/90caafbaf8b8b5f61459598a9845c8b0470b1fa6e9bc102d901a88deb73c7991.jpeg",
    "https://cdn.faire.com/fastly/d67cc7459d2051ebb4b61fa47ad2f62db23ce350ef37bbbe749c589097ff7533.jpeg",
    "https://cdn.faire.com/fastly/d56270d994e1b1fe766ab082fdb083e1f40977a8029cb5b9c5819a8ae657e4f6.jpeg",
    "https://cdn.faire.com/fastly/dbe6fb8ff798d299b0dc9b2a0f8781134790ca5794d67aaf6ef07ed60780fc6c.jpeg",
    "https://cdn.faire.com/fastly/46968de920b995fda45d6ed9d29323bacbcb4e6d896c5836ce93b0f7a2c8a8e5.jpeg",
    "https://cdn.faire.com/fastly/58280cb55b2215f5f7f90867157a9a01a1d9f03763b4cbfaa4d967f44257c471.jpeg",
    "https://cdn.faire.com/fastly/2e284909a823e6ea17070dea03020a8c2b9036d262f5e2805956172cf618b748.jpeg",
    "https://cdn.faire.com/fastly/b6b0b063931b5c669f0e0c764b8b92fc98fdb629f9950669bbf05832139c68cd.jpeg",
    "https://cdn.faire.com/fastly/2168d154e0188f4d9d7b20196d7440475531f5c51c8471c57f3648c649b6751e.jpeg",
  ],
  priceDollars: 27.5,
  description:
    "Expertly hand-crafted in Sri Lanka using raw coloured porcelain clay. This minimalist plant pot has a soft form and a pleasing hand feel designed to elevate your greenery of choice. Whilst desirable on its own, this pot thrives when placed together with other members of the Botany family.\n\nThis size is well suited to bookshelves, mantle pieces, coffee tables and window sill. Great for medium-sized plants.\n\nPlease note that due to the nature of the material, colour variation may occur.\nOur photos should be used as a guide.\n\nSize: Height 15.3cm, Diameter 15cm\n\nMaterial: ​Porcelain\n\nPorcelain is one of the strongest ceramics and it ages beautifully. The material’s low porosity means it won’t leak onto your table or floor, and can confidently withstand all outdoor weather conditions.",
  tags: [],
  msrpDollars: 55,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:20.801Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
